import type { ComputedRef, Ref } from "vue";

export interface IUseListFilterOptions {
  searchValue?: Ref<string> | ComputedRef<string>;
  searchProperty?: string;
}

/**
 * Will return a list of items sliced with the specified limit options.
 */
export default function useListFilter<T>(items: Ref<T[]>, options: IUseListFilterOptions): Ref<T[]> {
  const filterBy = (item: T, key?: string): boolean => {
    const search = options.searchValue?.value?.toLowerCase().trim() || "";
    if (item[key as keyof T])
      return String(item[key as keyof T]).toLowerCase().startsWith(search);
    return false;
  };

  if (options.searchProperty)
    return computed(() => items.value.filter(item => filterBy(item, options.searchProperty)));

  return items;
}
